import { Button, EmptyState } from '@ashniva/ui';
import { Link } from 'react-router';

import { SETTINGS_PATH, problemCopy } from '../problem-copy';
import { useRepositoryIntelligenceAccess } from '../ri-access';
import { classifyProblem } from '../ri-problems';

interface ProblemNoticeProps {
  /** What the request failed with. Only its status (and Desk's fixed text) is read; nothing of it is shown. */
  error: unknown;
  onRetry?: () => void;
  size?: 'sm' | 'md';
}

/** Why something could not be shown, in the screens' words, with the next step (MASTER-SPEC §14.4). */
export function ProblemNotice({ error, onRetry, size = 'md' }: ProblemNoticeProps) {
  const access = useRepositoryIntelligenceAccess();
  const copy = problemCopy(classifyProblem(error), access.manage);
  let action = null;
  if (copy.next === 'retry' && onRetry) {
    action = <Button onClick={onRetry}>Try again</Button>;
  } else if (copy.next === 'settings') {
    action = <Link to={SETTINGS_PATH}>Open Repository Intelligence settings</Link>;
  }
  return (
    <div className="ri-notice" role="status">
      <EmptyState
        size={size}
        icon={copy.icon}
        title={copy.title}
        description={copy.description}
        action={action}
      />
    </div>
  );
}
